import { plainToClass, classToPlain } from '../../../../../node_modules/.pnpm/class-transformer@0.5.1/node_modules/class-transformer/esm5/index.js';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SessionStoragePersistence = /*#__PURE__*/function () {
  function SessionStoragePersistence(param) {
    _classCallCheck(this, SessionStoragePersistence);
    this.type = void 0;
    this.key = void 0;
    if (param) {
      if (typeof param === 'string') {
        this.key = param;
      } else {
        this.type = param;
      }
    }
  }
  _createClass(SessionStoragePersistence, [{
    key: "useKey",
    value: function useKey(key) {
      this.key = key;
    }
  }, {
    key: "exists",
    value: function exists() {
      var _window, _window$sessionStorag;
      var data = (_window = window) === null || _window === void 0 ? void 0 : (_window$sessionStorag = _window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem(this.key);
      return data !== undefined && data !== null;
    }
  }, {
    key: "get",
    value: function get() {
      var _window2, _window2$sessionStora;
      var data = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$sessionStora = _window2.sessionStorage) === null || _window2$sessionStora === void 0 ? void 0 : _window2$sessionStora.getItem(this.key);
      if (data != null) {
        if (this.type) {
          return plainToClass(this.type, JSON.parse(data) || {});
        }
        return JSON.parse(data);
      }
      return plainToClass(this.type, {});
    }
  }, {
    key: "set",
    value: function set(instance) {
      var _window3, _window4;
      if (this.type && ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.sessionStorage) !== undefined) {
        window.sessionStorage.setItem(this.key, JSON.stringify(classToPlain(instance)));
      } else if (((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.sessionStorage) !== undefined) {
        window.sessionStorage.setItem(this.key, JSON.stringify(instance));
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _window5, _window5$sessionStora;
      (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$sessionStora = _window5.sessionStorage) === null || _window5$sessionStora === void 0 ? void 0 : _window5$sessionStora.removeItem(this.key);
    }
  }]);
  return SessionStoragePersistence;
}();

export { SessionStoragePersistence as default };
//# sourceMappingURL=SessionStoragePersistence.js.map
